const logoSliderIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V13.061C1.53659 13.7682 2.10988 14.3415 2.81707 14.3415H18.1829C18.8901 14.3415 19.4634 13.7682 19.4634 13.061V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V13.061C0 14.6168 1.26125 15.878 2.81707 15.878H18.1829C19.7388 15.878 21 14.6168 21 13.061V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
      fill="#6B00DF"
    />
    <path
      d="M4.63024 9.18366H6.39732V9.73171H4.00537V6.21805H4.63024V9.18366Z"
      fill="#6B00DF"
    />
    <path
      d="M8.20785 9.76244C7.21931 9.76244 6.47151 9.09146 6.47151 7.98512C6.47151 6.87878 7.21931 6.18219 8.20785 6.18219C9.19638 6.18219 9.94419 6.85829 9.94419 7.96463C9.94419 9.07098 9.19638 9.76244 8.20785 9.76244ZM8.20785 9.21951C8.81736 9.21951 9.30907 8.75341 9.30907 7.97488C9.30907 7.19122 8.81736 6.73024 8.20785 6.73024C7.59834 6.73024 7.10663 7.19122 7.10663 7.97488C7.10663 8.75341 7.59834 9.21951 8.20785 9.21951Z"
      fill="#6B00DF"
    />
    <path
      d="M12.0888 7.89293H13.6101V9.73171H13.1542V9.17854C12.9391 9.52171 12.5703 9.76244 12.0018 9.76244C11.0235 9.76244 10.3781 9.06585 10.3781 7.96463C10.3781 6.90439 11.044 6.18219 12.0735 6.18219C13.0057 6.18219 13.5127 6.72 13.5845 7.42171H12.9596C12.8981 7.06317 12.6471 6.73024 12.0735 6.73024C11.4332 6.73024 11.0081 7.21171 11.0081 7.96976C11.0081 8.75854 11.423 9.21951 12.0325 9.21439C12.6523 9.21951 12.9954 8.80463 13.0415 8.38463H12.0888V7.89293Z"
      fill="#6B00DF"
    />
    <path
      d="M15.8408 9.76244C14.8522 9.76244 14.1044 9.09146 14.1044 7.98512C14.1044 6.87878 14.8522 6.18219 15.8408 6.18219C16.8293 6.18219 17.5771 6.85829 17.5771 7.96463C17.5771 9.07098 16.8293 9.76244 15.8408 9.76244ZM15.8408 9.21951C16.4503 9.21951 16.942 8.75341 16.942 7.97488C16.942 7.19122 16.4503 6.73024 15.8408 6.73024C15.2312 6.73024 14.7395 7.19122 14.7395 7.97488C14.7395 8.75341 15.2312 9.21951 15.8408 9.21951Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.84146 20.4878C4.54866 20.4878 5.12195 19.9145 5.12195 19.2073C5.12195 18.5001 4.54866 17.9268 3.84146 17.9268C3.13427 17.9268 2.56098 18.5001 2.56098 19.2073C2.56098 19.9145 3.13427 20.4878 3.84146 20.4878ZM3.84146 21C4.83153 21 5.63415 20.1974 5.63415 19.2073C5.63415 18.2172 4.83153 17.4146 3.84146 17.4146C2.85139 17.4146 2.04878 18.2172 2.04878 19.2073C2.04878 20.1974 2.85139 21 3.84146 21Z"
      fill="#6B00DF"
    />
    <path
      d="M12.2927 19.2073C12.2927 20.1974 11.4901 21 10.5 21C9.50993 21 8.70732 20.1974 8.70732 19.2073C8.70732 18.2172 9.50993 17.4146 10.5 17.4146C11.4901 17.4146 12.2927 18.2172 12.2927 19.2073Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1585 20.4878C17.8657 20.4878 18.439 19.9145 18.439 19.2073C18.439 18.5001 17.8657 17.9268 17.1585 17.9268C16.4513 17.9268 15.878 18.5001 15.878 19.2073C15.878 19.9145 16.4513 20.4878 17.1585 20.4878ZM17.1585 21C18.1486 21 18.9512 20.1974 18.9512 19.2073C18.9512 18.2172 18.1486 17.4146 17.1585 17.4146C16.1685 17.4146 15.3659 18.2172 15.3659 19.2073C15.3659 20.1974 16.1685 21 17.1585 21Z"
      fill="#6B00DF"
    />
  </svg>
);

export { logoSliderIcon };
